import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BoUser from '../pages/index';
import EditBoUser from '../pages/edit';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import { RouteNameEnum } from '../../../enums/routeName';
import { PermissionEnum } from '../../../enums/permission';

const routes = [
  {
    privateProperties: {
      permissionCodes: [PermissionEnum.code.adminViewList],
    },
    routeProperties: {
      path: RouteNameEnum.boUser.index,
      element: <BoUser />,
    },
  },
  {
    privateProperties: {
      permissionCodes: [
        PermissionEnum.code.adminEditDetail,
        PermissionEnum.code.adminEditRole,
        PermissionEnum.code.adminEditStatus,
      ],
      redirectUrl: RouteNameEnum.boUser.index,
    },
    routeProperties: {
      path: RouteNameEnum.boUser.edit,
      element: <EditBoUser />,
    },
  },
];

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      { routes.map((route) => (
        <Route
          key={route.routeProperties.path}
          element={<PrivateOutlet {...route.privateProperties} />}
        >
          <Route {...route.routeProperties} />
        </Route>
      ))}
    </Route>
  </Routes>
);

export default BaseRoutes;
